module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pattern-gallery"
  }, [_vm._l((_vm.patterns), function(p) {
    return [_c('router-link', {
      staticClass: "link",
      attrs: {
        "to": _vm.getPatternLink(p)
      }
    }, [_c('div', {
      staticClass: "preview"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(p.preview)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "caption-container"
    }, [_c('div', {
      staticClass: "caption alt-font"
    }, [_vm._v(_vm._s(p.name))])])]), _vm._v(" "), _c('div', {
      staticClass: "alt-font"
    }, [_vm._v(_vm._s(p.name))])])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d68c87e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/PatternGallery.vue
// module id = 562
// module chunks = 1